<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasStore="true"
      :hasCustomer="true"
      :hasEmployee="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["all", "sale", "store"],
      reportType: "all",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "sale") {
        return [
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "StoreName" },
          { name: "TerminalName" },
          { name: "BusinessDay" },
          { name: "SalNumber" },
          { name: "EmployeeName" },
          { name: "SalTime" },
          { name: "Total" },
          { name: "BeforeDeposit" },
          { name: "Deposit" },
          { name: "AfterDeposit" },
        ];
      } else if (this.reportType == "store") {
        return [
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "StoreName" },
          { name: "TerminalName" },
          { name: "DepositRecordNumber" },
          { name: "TradeType" },
          { name: "BusinessDay" },
          { name: "EmployeeName" },
          { name: "TradeTime" },
          { name: "Total" },
          { name: "FreeDeposit" },
          { name: "DiscountPrice" },
          { name: "Discount" },
          { name: "BeforeDeposit" },
          { name: "Deposit" },
          { name: "AfterDeposit" },
        ];
      } else if (this.reportType == "all") {
        return [
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "StoreName" },
          { name: "TerminalName" },
          { name: "TradeNumber" },
          { name: "TradeType" },
          { name: "BusinessDay" },
          { name: "EmployeeName" },
          { name: "TradeTime" },
          { name: "Total" },
          { name: "BeforeDeposit" },
          { name: "Deposit" },
          { name: "AfterDeposit" },
        ];
      } else return undefined;
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getDeposit(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getDeposit(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printDeposit(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getDeposit(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
